/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="88.83"
        height="95.58"
        viewBox="0 0 88.83 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M5.86 35.77a1.25 1.25 0 0 1 .88 2.34 6.58 6.58 0 0 0 2.88 12.71 1.25 1.25 0 1 1 .2 2.49 9.08 9.08 0 0 1-4-17.54Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M69.68 46.64a2.29 2.29 0 1 1-2.29-2.28 2.29 2.29 0 0 1 2.29 2.28"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M72.2 23.04a1.25 1.25 0 0 1 1.16 1.69l-.28.77-.26.74-.25.74-.12.36-.21.7c-.11.35-.21.7-.3 1l-.17.67c-.11.43-.2.85-.29 1.26l-.11.6c-.49 2.77-.33 4.82.6 5.82l.9.92 2.91 2.91.61.61.65.69.41.43.46.52.1.12c1.33 1.58 5.06 2.55 9.66 2.89a1.24 1.24 0 0 1 1.15 1.13v.13l-.1 11.83a1.26 1.26 0 0 1-.29.79l-.1.11-13 12.4a.49.49 0 0 0-.12.13c-.32.42-.64.82-1 1.21a.76.76 0 0 0-.12.19v.1l-7.84 20.25a1.24 1.24 0 0 1-1 .8h-6.79a1.24 1.24 0 0 1-1.22-1v-.12l-1.12-8.23a.66.66 0 0 0-.32-.5.68.68 0 0 0-.59-.08 38 38 0 0 1-22.22 0 .72.72 0 0 0-.59.08.79.79 0 0 0-.3.4v.1L31 94.5a1.26 1.26 0 0 1-1.12 1.09h-6.76a1.24 1.24 0 0 1-1.14-.74v-.12l-6.34-19.81a1 1 0 0 0-.11-.21l-.08-.1-.31-.36a26.72 26.72 0 0 1-6.36-16.83v-.5A26.78 26.78 0 0 1 20.6 34.65a1.254 1.254 0 0 1 1.4 2.08 24.3 24.3 0 0 0-5 35.86l.32.37a3.43 3.43 0 0 1 .55.89l.09.21 6.09 19h4.65l.9-7.09a3.23 3.23 0 0 1 1.29-2.17l.16-.11a3.24 3.24 0 0 1 2.68-.37 35.47 35.47 0 0 0 20.74 0 3.21 3.21 0 0 1 4.1 2.44v.2l1 7.14h4.67l7.53-19.45a3.3 3.3 0 0 1 .44-.8l.14-.19c.3-.35.59-.73.87-1.1a2.48 2.48 0 0 1 .25-.3l.15-.15 12.63-12 .09-10.15h-.17c-4.51-.45-8.06-1.48-9.88-3.45l-.17-.2-.19-.22-.21-.24-.37-.4-.6-.63-1-1-3-3-.65-.66c-2.21-2.38-2-6.75-.11-12.49l.26-.79v-.12c-2.7.6-5.36 2.51-7.76 5.17l-.27.31a3.56 3.56 0 0 1-3.92 1 37.13 37.13 0 0 0-4.56-1.43 1.25 1.25 0 0 1 .59-2.43 41 41 0 0 1 4.86 1.52 1 1 0 0 0 1.14-.28c3.5-3.98 7.51-6.62 11.87-6.58Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M35.6 0A21.44 21.44 0 1 0 57 21.44 21.44 21.44 0 0 0 35.6 0Zm0 2.5a18.94 18.94 0 1 1-18.94 18.94A18.94 18.94 0 0 1 35.6 2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M34.4 8.34v2.21l-.34.06-.35.07a5.26 5.26 0 0 0-4 3.23 6.46 6.46 0 0 0-.46 3A5.18 5.18 0 0 0 32 21.32a22.9 22.9 0 0 0 2.31 1c1 .41 2 .78 2.92 1.19a1.77 1.77 0 0 1 1.14 1.99 1.91 1.91 0 0 1-1.54 1.92 5.66 5.66 0 0 1-1.23.08 3 3 0 0 1-3.11-2.27c-.09-.27-.15-.55-.23-.85l-3.7.95a7.73 7.73 0 0 0 1.79 3.66 6.28 6.28 0 0 0 4.05 1.91v2.85h2.39v-2.83c.48-.09.94-.17 1.4-.29a5.52 5.52 0 0 0 3.89-3.13 6.37 6.37 0 0 0 .44-3.85 5.07 5.07 0 0 0-2.58-3.67 27.06 27.06 0 0 0-3.54-1.54c-.72-.29-1.43-.63-2.13-1a1.52 1.52 0 0 1-.79-1A2.16 2.16 0 0 1 35 13.77a2.49 2.49 0 0 1 2.47.65 4.87 4.87 0 0 1 1 1.52c.08.18.15.36.23.56l3.3-1.37a6.7 6.7 0 0 0-1.21-2.49 5.81 5.81 0 0 0-4-2.09V8.34Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'PiggybankWithCoinIcon';

export default Icon;
